import { render, staticRenderFns } from "./CangTabBar.vue?vue&type=template&id=3a64099a&scoped=true&"
import script from "./CangTabBar.vue?vue&type=script&lang=js&"
export * from "./CangTabBar.vue?vue&type=script&lang=js&"
import style0 from "./CangTabBar.vue?vue&type=style&index=0&id=3a64099a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64099a",
  null
  
)

export default component.exports